"use client";

import { Prose } from "@/components/custom/Prose";
import { useCart } from "@/queries/useCart";
import type { ProseDocument } from "./types";

interface Props {
  headline: string;
  proseContent?: ProseDocument;
}

export function ReorderSection({ headline, proseContent }: Props) {
  const { data: cart } = useCart();
  const hasReorderItem = cart?.items?.some(item => item.isReorder);
  if (!hasReorderItem) return null;

  return (
    <section className="space-y-2 px-5 pt-12">
      <h2 className="text-2xl">{headline}</h2>
      {proseContent ? <Prose content={proseContent} className="text-sm" /> : null}
    </section>
  );
}
